<template>
    <div class="table-responsive">
        <table class="table table-bordered bg-white table-hover">
            <caption>
                <p>
                    <i class="fa fa-minus"></i>&nbsp;Costo de gastos de tramite
                    es un valor promedio estimado.
                </p>
            </caption>
            <thead>
                <tr>
                    <th colspan="2">Costo Total</th>
                </tr>
            </thead>
            <tbody class="text-right">
                <tr>
                    <td>Precio de Vehículo <span class="asterisk">*</span></td>
                    <td>
                        $ {{ formatPrice(vehiculoData.precio_publicacion) }}
                    </td>
                </tr>
                <tr>
                    <td>Gestoria de Tramite <span class="asterisk">*</span></td>
                    <td>$ {{ formatPrice(tramites) }}</td>
                </tr>
                <tr>
                    <td>Peritaje <span class="asterisk">*</span></td>
                    <td>$ {{ formatPrice(peritaje_front) }}</td>
                </tr>
                <tr>
                    <td>Alistamiento</td>
                    <td>$ {{ formatPrice(alistamiento) }}</td>
                </tr>
            </tbody>
            <tfoot class="text-right">
                <tr>
                    <td><b>Costo total, todo incluido</b></td>
                    <td>
                        <strong>$ {{ formatPrice(costo_total) }}</strong>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import mainHelper from "helpers/main-helper";
export default {
    computed: {
        inspeccionLegalData() {
            return this.$store.state.fichaTecnica.vehiculo.tabs.ficha_tecnica;
        },
        vehiculoData() {
            return this.$store.state.fichaTecnica.vehiculo.info_vehiculo
                .vehiculo;
        },
        precioData() {
            return this.$store.state.fichaTecnica.vehiculo.vr_retoma;
        }
    },
    created() {
        var gastos = this.inspeccionLegalData.gastos_traspaso.comprador;
        var otros = this.inspeccionLegalData.gastos_traspaso.gastos;
        this.precio_vehiculo = this.vehiculoData.precio_publicacion;
        this.peritaje_front = otros.peritaje;
        this.alistamiento = gastos.cp_alistamiento;
        this.tramites =
            gastos.cp_derechos +
            gastos.cp_impuestos +
            gastos.cp_cert_tradicion +
            gastos.cp_honorarios;
        this.costo_total =
            this.precio_vehiculo +
            this.peritaje_front +
            this.alistamiento +
            this.tramites;
    },
    data: () => ({
        precio_vehiculo: 0,
        peritaje_front: 0,
        alistamiento: 0,
        tramites: 0,
        costo_total: 0
    }),
    methods: {
        formatPrice(number) {
            return mainHelper.numberWithDotsNotRounded(number);
        }
    }
};
</script>

<style lang="scss" scoped>
span.asterisk {
    color: #ff1414;
}
li.li-cost {
    list-style: none;
}
</style>
